export const BASE_URL = process.env.GATSBY_BASE_URL;
